import { render, staticRenderFns } from "./BuyFeedback.vue?vue&type=template&id=8f755c5c"
import script from "./BuyFeedback.vue?vue&type=script&lang=js"
export * from "./BuyFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports